<template>
    <v-dialog v-model="dialog" max-width="800" persistent>
      <v-card>
        <v-card-title class="headline">新增校招信息</v-card-title>
        <v-divider></v-divider>
  
        <v-card-text class="pt-4">
          <v-form ref="form" v-model="valid">
            <v-row>
                <!-- 左侧列 -->
              <v-col cols="6">
                <v-select
                  v-model="formData.industryTypeId"
                  :items="industryTypes"
                  item-text="name"
                  item-value="id"
                  label="行业类型"
                  outlined
                  :rules="[v => !!v || '必填项']"
                ></v-select>
  
                <v-select
                  v-model="formData.companyTypeId"
                  :items="companyTypes"
                  item-text="name"
                  item-value="id"
                  label="公司类型"
                  outlined
                  :rules="[v => !!v || '必填项']"
                  class="mb-4"
                ></v-select>
  
                <v-select
                  v-model="formData.recruitmentTypeId"
                  :items="recruitmentTypes"
                  item-text="name"
                  item-value="id"
                  label="招聘类型"
                  outlined
                  :rules="[v => !!v || '必填项']"
                  class="mb-4"
                ></v-select>
  
                <v-select
                  v-model="formData.recruitmentChannelId"
                  :items="recruitmentChannels"
                  item-text="name"
                  item-value="id"
                  label="招聘渠道"
                  outlined
                  :rules="[v => !!v || '必填项']"
                  class="mb-4"
                ></v-select>
  
                <v-select
                  v-model="formData.recruitmentAreaId"
                  :items="recruitmentAreas"
                  item-text="name"
                  item-value="id"
                  label="招聘地区"
                  outlined
                  :rules="[v => !!v || '必填项']"
                  class="mb-4"
                ></v-select>
  
                <v-text-field
                  v-model="formData.newsTitle"
                  label="招聘信息标题"
                  outlined
                  :rules="[v => !!v || '必填项']"
                ></v-text-field>

                <v-text-field
                  v-model="formData.workPlace"
                  label="工作地点"
                  outlined
                  class="mb-4"
                ></v-text-field>
              </v-col>

            <!-- 右侧列 -->
              <v-col cols="6">
                <v-text-field
                  v-model="formData.submissionLink"
                  label="投递链接"
                  outlined
                  :rules="[
                    v => !!v || '必填项',
                    v => /^(http|https):\/\/.+/.test(v) || '请输入有效URL'
                  ]"
                ></v-text-field>

                <v-text-field
                  v-model="formData.recruitmentTarget"
                  label="招聘对象"
                  outlined
                  class="mb-4"
                ></v-text-field>
  
                <v-textarea
                  v-model="formData.newsContent"
                  label="招聘内容"
                  outlined
                  rows="4"
                  class="mb-4"
                ></v-textarea>
  
                <v-textarea
                  v-model="formData.remark"
                  label="备注"
                  outlined
                  rows="2"
                  class="mb-4"
                ></v-textarea>


                <v-row>
            <v-col cols="6">
              <v-menu
                v-model="dateMenu.start"
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="auto"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formData.submissionStartDate"
                    label="投递开始日期"
                    prepend-icon="mdi-calendar"
                    readonly
                    clearable
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formData.submissionStartDate"
                  @input="dateMenu.start = false"
                  :max="formData.submissionEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="6">
              <v-menu
                v-model="dateMenu.end"
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="auto"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formData.submissionEndDate"
                    label="投递截止日期"
                    prepend-icon="mdi-calendar"
                    readonly
                    clearable
                    v-on="on"
                    :min="formData.submissionStartDate"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formData.submissionEndDate"
                  @input="dateMenu.end = false"
                  :min="formData.submissionStartDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
                <v-menu
                  v-model="dateMenu.updateAt"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="formData.updateAt"
                      label="更新日期"
                      readonly
                      outlined
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData.updateAt"
                    @input="dateMenu.updateAt = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close">取消</v-btn>
          <v-btn 
            color="primary" 
            @click="create"
            :loading="saving"
            :disabled="!valid"
          >
            建立
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import { adminApi } from '@/api/admin'
  import { dropdownOptionsApi } from '@/api/dropdownOptions'
  import dayjs from 'dayjs'
  
  export default {
    data() {
      return {
        dialog: false,
        valid: false,
        saving: false,
        formData: {
          industryTypeId: null,
          companyTypeId: null,
          recruitmentTypeId: null,
          recruitmentChannelId: null,
          recruitmentAreaId: null,
          newsTitle: '',
          recruitmentTarget: '',
          submissionLink: '',
          workPlace: '',
          remark: '',
          newsContent: '',
          submissionStartDate: null,
          submissionEndDate: null,
          updateAt: dayjs().format('YYYY-MM-DD')
        },
        // 下拉选项相关数据（同编辑组件）
        industryTypes: [],
        companyTypes: [],
        recruitmentTypes: [],
        recruitmentChannels: [],
        recruitmentAreas: [],
        dateMenu: {
          start: false,
          end: false
        }
      }
    },
  
    created() {
      this.loadDropdownOptions()
    },
  
    methods: {
      open() {
        this.dialog = true
      },
  
      async create() {
        if (!this.$refs.form.validate()) return
  
        this.saving = true
        try {
          const payload = {
            ...this.formData,
            industryTypeId: Number(this.formData.industryTypeId),
            companyTypeId: Number(this.formData.companyTypeId),
            recruitmentTypeId: Number(this.formData.recruitmentTypeId),
            recruitmentChannelId: Number(this.formData.recruitmentChannelId),
            recruitmentAreaId: Number(this.formData.recruitmentAreaId),
            submissionStartDate: this.formatDate(this.formData.submissionStartDate),
            submissionEndDate: this.formatDate(this.formData.submissionEndDate),
            tagIds: []
          }
  
          const response = await adminApi.createIntershipNews(payload)
          
          if (response.code === '2000') {
            this.$emit('saved')
            this.$toast.success('创建成功')
            this.close()
          }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || '未知错误';
            this.$toast.error('创建失败：' + errorMessage);
        } finally {
          this.saving = false
        }
      },
  
      close() {
        this.dialog = false
        this.$refs.form.reset()
      },
  
        // 以下方法与编辑组件相同
        async loadDropdownOptions() {
            this.loadingOptions = true
            try {
                const requests = [
                    dropdownOptionsApi.getIndustryTypes(),
                    dropdownOptionsApi.getCompanyTypes(),
                    dropdownOptionsApi.getRecruitmentTypes(),
                    dropdownOptionsApi.getRecruitmentChannels(),
                    dropdownOptionsApi.getRecruitmentAreas()
                ]

            const [
                    industryRes,
                    companyRes,
                    recruitmentTypeRes,
                    recruitmentChannelRes,
                    recruitmentAreaRes
                ] = await Promise.all(requests)

                this.industryTypes = this.formatOptions(industryRes.data)
                this.companyTypes = this.formatOptions(companyRes.data)
                this.recruitmentTypes = this.formatOptions(recruitmentTypeRes.data)
                this.recruitmentChannels = this.formatOptions(recruitmentChannelRes.data)
                this.recruitmentAreas = this.formatOptions(recruitmentAreaRes.data)
            } catch (error) {
                const errorMessage = error.response?.data?.message || error.message || '未知错误';
                this.$toast.error('无法加载下拉选项数据 : ' + errorMessage);
            } finally {
                this.loadingOptions = false
            }
        },
        formatDate(date) {
            return date ? dayjs(date).format('YYYY-MM-DD') : null
        },
        formatOptions(data) {
            return data?.map(item => ({
                name: item.name,
                id: Number(item.id) // 确保转换为数字类型
            })) || []
        },
    }
  }
  </script>